import { ListClinic } from '@chiroup/core/types/Clinic.type';
import { useMemo, useState } from 'react';
import AdHocReportCard from '../../ad-hoc-reports/AdHocReportCard';
import { adHocReportRegistry } from '../../ad-hoc-reports/adHocReportRegistry';

type Props = {
  clinic: Partial<ListClinic>;
};

const ClinicAdHocReports = ({ clinic }: Props) => {
  const clinicId = clinic.ID;
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();

    if (!q) return adHocReportRegistry;

    return adHocReportRegistry.filter(d => d.name.toLowerCase().includes(q));
  }, [search]);

  if (!clinicId) return null;

  return (
    <div className="p-6 space-y-6">
      <input
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Filter reports..."
        className="w-full max-w-sm rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-dark-gray-800 px-3 py-2 text-sm"
      />
      {filtered.map(descriptor => (
        <AdHocReportCard
          key={`${descriptor.id}-${clinicId}`}
          descriptor={descriptor}
          clinicId={clinicId}
        />
      ))}
    </div>
  );
};

export default ClinicAdHocReports;
